/**
 * Header de la page detail dossier : nom client + badge mandataire + statut
 * + nb velos.
 */

import { Link } from 'react-router-dom';
import StatusBadgeLarge from '../components/StatusBadgeLarge.jsx';

/** @param {string|null|undefined} siren @returns {string} */
function formatSiren(siren) {
  if (!siren) return '';
  const d = String(siren).replace(/\D/g, '');
  if (d.length !== 9) return siren;
  return `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6, 9)}`;
}

/**
 * @param {{ dossier: object | null }} props
 */
export default function DetailHeader({ dossier }) {
  if (!dossier) return null;
  const m = dossier.mandataire || {};
  const c = dossier.client || {};
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 mb-5">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
        <div>
          <Link to="/cee/dossiers" className="text-xs text-blue-600 hover:underline">
            &larr; Retour
          </Link>
          <h1 className="text-2xl font-bold text-[#0f172a] mt-1">{c.name || 'Dossier'}</h1>
          <div className="mt-1 flex items-center gap-2 text-sm text-[#64748b]">
            {c.siren && <span>SIREN {formatSiren(c.siren)}</span>}
            {c.city && <span>· {c.city}</span>}
            {m.code && (
              <span className={`px-2 py-0.5 rounded-md text-[10px] font-bold uppercase ${
                m.code === 'FEH' ? 'bg-blue-100 text-blue-700' : 'bg-orange-100 text-orange-700'
              }`}>
                {m.code} - {m.nom}
              </span>
            )}
          </div>
        </div>
        <div className="flex flex-col items-end gap-2">
          <StatusBadgeLarge status={dossier.status} blockingReason={dossier.blockingReason} />
          <div className="text-xs text-[#475569]">
            {dossier.velosLivres || 0} / {dossier.velosQuota || 0} velos livres
          </div>
        </div>
      </div>
    </div>
  );
}
